import parseHTML from "../../lib/dom/funciones/parse_html";
var desplazadorDeLinea = function (linea, direccion) {
    var elemento = linea.querySelector('.linea_de_tiempo__linea__hito:nth-child(2)');
    return function () {
        return linea.scroll({
            left: linea.scrollLeft + direccion * elemento.offsetLeft,
            behavior: 'smooth'
        });
    };
};
var lineaDeTiempo = function () {
    var hitos = Array.from(document.querySelectorAll('.linea_de_tiempo__hitos')), lineas = hitos.map(function (tabla) { return tabla.querySelector('ol'); });
    if (hitos.length === 0) {
        return;
    }
    hitos.forEach(function (hito, i) {
        var anterior = parseHTML('<button class="linea_de_tiempo__anterior" disabled>Anterior</button>'), siguiente = parseHTML('<button class="linea_de_tiempo__siguiente">Siguiente</button>'), navegacion = parseHTML('<div class="linea_de_tiempo__navegacion"></div>');
        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);
        hito.appendChild(navegacion);
        anterior.addEventListener('click', desplazadorDeLinea(lineas[i], -1));
        siguiente.addEventListener('click', desplazadorDeLinea(lineas[i], 1));
        lineas[i].addEventListener('scroll', function () {
            anterior.disabled = lineas[i].scrollLeft === 0;
            siguiente.disabled = Math.abs(lineas[i].scrollLeft + lineas[i].clientWidth - lineas[i].scrollWidth) < 2;
        });
    });
    var ajustaScrolls = function () { return lineas.forEach(function (inner, i) {
        if (inner.scrollWidth > inner.clientWidth) {
            hitos[i].classList.add('is-scrollable');
        }
        else {
            hitos[i].classList.remove('is-scrollable');
        }
    }); };
    var ajustaDistancia = function (inner, i) { return function () {
        hitos[i].style.setProperty('--distancia-izquierda', inner.scrollLeft + 'px');
        hitos[i].style.setProperty('--distancia-derecha', inner.scrollWidth - inner.clientWidth - inner.scrollLeft + 'px');
    }; };
    addEventListener('resize', ajustaScrolls);
    addEventListener('load', ajustaScrolls);
    ajustaScrolls();
    lineas.forEach(function (inner, i) {
        var ajustador = ajustaDistancia(inner, i);
        inner.addEventListener('scroll', ajustador);
        addEventListener('resize', ajustador);
        addEventListener('load', ajustador);
    });
};
export default lineaDeTiempo;
